<div class="text">
    <p class="icon-text">
        <span class="material-icons">diamond</span>
        We are proudly 100% <a href="https://en.wikipedia.org/wiki/Diamond_open_access"> Diamond Open
            Access</a>
    </p>

    <p>
        Our commitment to <strong>Diamond Open Access</strong> ensures that <em>no fees</em> are charged for both
        authors
        and readers. This model promotes a more inclusive and equitable access to knowledge by removing financial
        barriers to publishing and reading academic work.
    </p>

    <p><strong>Diamond Open Access</strong> means:</p>

    <ul>
        <li><strong>No publication fees:</strong> Authors can publish their work without paying any processing fees.
        </li>
        <li><strong>Free access for all:</strong> Readers can access all content without any cost, ensuring widespread
            dissemination of knowledge.</li>
    </ul>

    <p>
        <!--This reflects our mission to encourage open and global access to scientific research, ensuring that
        knowledge can be shared and utilized by all.-->
    </p>
</div>

<div class="text">
    <p class="icon-text"> <span class="material-icons">copyright</span> Published under <a
            href="https://creativecommons.org/licenses/by-sa/4.0/"> Creative Commons CC-BY 4.0</a> </p>
    <p>
        This license encourages open and unrestricted sharing of scientific research.
        You are free to:
    </p>
    <ul>
        <li><strong>Share:</strong> Copy and distribute this content in any format and for any purpose, including
            commercial use.</li>
        <li><strong>Adapt:</strong> Remix, transform, and build upon this content for any purpose, including commercial
            use.</li>
    </ul>
    <p>
        If you modify the content, you are only required to credit the original work and note any changes
        made. This ensures that knowledge remains open and accessible.
    </p>
    <p>
       De Cifris Koine Author<a href="https://drive.google.com/file/d/1qSb41rGQ-U1VbcZ5xbuq8DhTK3Kqm2pV" target="_blank">License Agreement</a>
    </p>
</div>